/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Curai Superclinical Service
 * OpenAPI spec version: 0.1.0
 */

export type GetStatusOfEncounterAssociatedWithCuraiVisitClinicVisitConversationIdStatusGetParams =
  {
    /**
     * If provided, the encounter is resolved through this ClinicRequest's created_clinic_conversation_id, which pins a single visit. Preferred over the path conversation_id: the Nori conv's curai_conversation_id forward pointer only tracks the most recent visit, so it returns the wrong visit's status once a conversation has multiple visits.
     */
    clinic_request_id?: string | null;
  };
